"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReceivableUpdateTransport = exports.ReceivableCreateResultTransport = exports.ReceivableCreateError = exports.ReceivableCreateTransport = exports.ReceivableTransport = exports.InvoiceSubscription = void 0;
const typebox_1 = require("@sinclair/typebox");
const commercial_1 = require("../../commercial");
const customer_1 = require("../../customer");
const operations_1 = require("../../operations/operations");
const ServiceGrouping_1 = require("../../service-orders/ServiceGrouping");
const invoice_transport_1 = require("./invoice-transport");
/**
 * Operations subscription this invoice bills, embedded so the PDF/detail/search paths need no
 * per-invoice subscription fetch. The nested `customer` is dropped — the receivable's top-level
 * `customer` is the source of truth (and avoids embedding customer secrets). Read-only.
 */
exports.InvoiceSubscription = typebox_1.Type.Omit(operations_1.Subscription, ['customer']);
/**
 * Unified billing (v2) receivable transport. Admin/hauler-facing — customer views use a separate
 * transport, so the embedded objects below carry the full internal shape.
 */
exports.ReceivableTransport = typebox_1.Type.Object({
    id: typebox_1.Type.String({ format: 'uuid' }),
    customerID: typebox_1.Type.String({ format: 'uuid' }),
    haulerID: typebox_1.Type.String({ format: 'uuid' }),
    invoiceDetails: invoice_transport_1.InvoiceTransport,
    /** Enriched from the customer service. Read-only. */
    customer: typebox_1.Type.Optional(customer_1.BaseCustomer),
    /** Operations subscriptions this invoice bills. One entry normally; multiple for combined invoices. Read-only. */
    subscriptions: typebox_1.Type.Optional(typebox_1.Type.Array(exports.InvoiceSubscription)),
    /**
     * Universal-service groupings this invoice bills (full `ServiceGrouping`). One entry normally;
     * multiple for combined invoices. Read-only.
     *
     * NOTE: universal service is being deprecated soon — expect this field to be removed in a
     * near-future cleanup once universal service is fully retired.
     */
    serviceGroupings: typebox_1.Type.Optional(typebox_1.Type.Array(ServiceGrouping_1.ServiceGrouping)),
    /** Legacy Wayste commercial subscriptions this invoice bills. Read-only. */
    commercialSubscriptions: typebox_1.Type.Optional(typebox_1.Type.Array(commercial_1.CommercialSubscriptionTransport)),
});
exports.ReceivableCreateTransport = typebox_1.Type.Object({
    customerID: typebox_1.Type.String({ format: 'uuid' }),
    mergedReceivableIDs: typebox_1.Type.Optional(typebox_1.Type.Array(typebox_1.Type.String({ format: 'uuid' }), { minItems: 2, uniqueItems: true })),
    invoiceDetails: invoice_transport_1.InvoiceCreateTransport,
});
/**
 * A reference or line item from `ReceivableCreateTransport` that could not be created. The receivable
 * and everything else sent with it still exist.
 */
exports.ReceivableCreateError = typebox_1.Type.Object({
    resource: typebox_1.Type.Union([typebox_1.Type.Literal('reference'), typebox_1.Type.Literal('lineItem')]),
    message: typebox_1.Type.String(),
});
exports.ReceivableCreateResultTransport = typebox_1.Type.Composite([
    exports.ReceivableTransport,
    typebox_1.Type.Object({ errors: typebox_1.Type.Array(exports.ReceivableCreateError) }),
]);
exports.ReceivableUpdateTransport = typebox_1.Type.Object({
    customerID: typebox_1.Type.Optional(typebox_1.Type.String({ format: 'uuid' })),
    invoiceDetails: typebox_1.Type.Optional(invoice_transport_1.InvoiceUpdateTransport),
});
//# sourceMappingURL=receivable-transport.js.map